









import { Header } from './components';

export default {
  components: {
    Header,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },

  computed: {
    isBackbtnSlotExists() {
      return this.$slots['backbtn'];
    },
  },

  mounted() {
    console.log(this.$slots['backbtn']);
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/components/top/Top.vue